import { useRef } from 'react';

import { DataGrid } from '@/features/table/components/DataGrid';
import { type DrillEx } from '@/modules/ISM/api/drills/schema';
import { type ColDef, type GridApi } from 'ag-grid-community';

interface DrillsTableProps {
  isLoading: boolean;
  drills: DrillEx[];
}

export const DrillsTable = ({ isLoading, drills }: DrillsTableProps) => {
  const gridApiRef = useRef<GridApi | null>(null);

  const columns: ColDef<DrillEx>[] = [
    {
      headerName: 'Vessel',
      valueGetter: (params) => params.data?.Vessel?.Name ?? '',
      flex: 2,
      filter: true,
      floatingFilter: true
    },
    {
      headerName: 'Drill Type',
      valueGetter: (params) => params.data?.DrillType?.Name ?? '',
      filter: true,
      floatingFilter: true
    },
    {
      headerName: 'Due Date',
      valueGetter: (params) => (params.data?.DueDate ? new Date(params.data.DueDate).toLocaleDateString() : ''),
      filter: true,
      floatingFilter: true
    },
    { headerName: 'Status', field: 'Status', filter: true, floatingFilter: true }
  ];

  const onGridReady = (params: { api: GridApi }) => {
    gridApiRef.current = params.api;
  };

  return (
    <div className="flex w-full flex-1 flex-col overflow-auto">
      <DataGrid
        columnDefs={columns}
        rowData={drills}
        onGridReady={onGridReady}
        domLayout="autoHeight"
        loading={isLoading}
      />
    </div>
  );
};
